import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import {
  PluginDecoratorModel,
  PluginModel,
  TemplateTypeModel,
} from '../model/plugin-decorator.model';

@Injectable({
  providedIn: 'root',
})
export class PluginDecorationDataService {
  private readonly pluginDecoratorPath =
    'assets/plugin-decorator/plugin-decorator.json';
  isTypeAvailable: TemplateTypeModel;
  private pluginDecoratorData: Observable<any>;
  constructor(private readonly http: HttpClient) {}

  getPluginDecoratorData(): Observable<any> {
    if (!this.pluginDecoratorData) {
      this.pluginDecoratorData = this.http
        .get(this.pluginDecoratorPath)
        .pipe(shareReplay(1));
    }
    return this.pluginDecoratorData;
  }

  getPluginDecorationData(type: string): Observable<TemplateTypeModel[]> {
    return this.getPluginDecoratorData().pipe(
      map((data: PluginDecoratorModel) =>
        this.pluginDecorationFilter(data, type)
      )
    );
  }

  pluginDecorationFilter(
    data: PluginDecoratorModel,
    type: string
  ): TemplateTypeModel[] {
    if (data.toggleTemplateDocHoverUI) {
      localStorage.setItem(
        'toggleTemplateDocHoverUI',
        data.toggleTemplateDocHoverUI
      );
    }

    if (data.enableInlineTrackChanges) {
      localStorage.setItem(
        'enableInlineTrackChanges',
        JSON.stringify(data.enableInlineTrackChanges)
      );
    }
    this.isTypeAvailable = data.pluginDecorator.find(
      (templateType: TemplateTypeModel) => {
        return templateType.type === type;
      }
    );

    if (this.isTypeAvailable) {
      return data.pluginDecorator.filter((templateType: TemplateTypeModel) => {
        return templateType.type === type;
      });
    } else {
      return null;
    }
  }

  getEnablePluginData(): Observable<PluginModel[]> {
    return this.getPluginDecoratorData().pipe(
      map((data: PluginDecoratorModel) => {
        return data.enablePlugin;
      })
    );
  }
}
